import { NavLink } from 'react-router-dom';

const TABS = [
  { to: '/reports/sales', label: 'Sales' },
  { to: '/reports/menu', label: 'Menu' },
  { to: '/reports/operations', label: 'Operations' },
];

/** Horizontal sub-nav rendered at the top of each /reports/* page. */
export function ReportSubNav() {
  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-8" aria-label="Report sections">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end
            className={({ isActive }) =>
              `py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                isActive
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
